import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { UserGridStateService } from '../user-grid-state.service';
import { HttpClient } from '@angular/common/http';
import { AgGridAngular } from 'ag-grid-angular';
import { 
  ColDef,
  GridApi,
  GridOptions,
  GridPreDestroyedEvent,
  GetRowIdFunc,
  GetRowIdParams,
  GridReadyEvent,
  GridState,
  StateUpdatedEvent,
  ICellRendererParams,
  IDatasource,
  IGetRowsParams,
  RowModelType,
  SortModelItem, 
  ValueGetterParams, 
  CellClassParams, 
  IServerSideGetRowsRequest, 
  IServerSideDatasource, 
  IServerSideGetRowsParams
} from 'ag-grid-community';
import { WorkOrder } from '../models/work-order.model';
import 'ag-grid-enterprise';
import { TooltipComponent } from '../work-orders/tooltip/tooltip.component';
import * as SelectList from '../work-orders/select-options';
import { DatePicker } from '../work-orders/date-picker/date-picker.component';
import { ActivatedRoute, Router } from '@angular/router';
import { IconCellRendererComponent } from '../icon-cell-renderer/icon-cell-renderer.component';
import { workOrderDefaultGridState } from '../default-grid-states/work-order-default-grid-state';


@Component({
  selector: 'app-test-grid',
  templateUrl: './test-grid.component.html',
  styleUrls: ['./test-grid.component.scss']
})
export class TestGridComponent implements OnInit{

public gridReady = false;

public columnDefs: ColDef[] = [
    {
      field: 'alternate_reference', headerName: 'FBI No.', width: 130, tooltipField: 'alternate_reference', tooltipComponentParams: { col: 'order_num' },
      cellRenderer: 'agGroupCellRenderer'// allows expand/collapse
    },
    {
      field: 'hot',
      headerName: 'Hot',
      cellRenderer: IconCellRendererComponent,
      cellRendererParams: {
        icon: 'fas fa-fire',
        color: 'red'
      },
      maxWidth: 90,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ['true', 'false']
      },
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: { values: ['yes', 'no'] },
      cellDataType: 'boolean',
    },
    { field: 'lading_uuid', headerName: 'Lading UUID', hide: true },
    { field: 'lading_number', headerName: 'BOL No.', width: 150 },
    { field: 'pro_bill', headerName: 'PRO Bill', width: 100 },
    { field: 'shipper_name', headerName: 'Shipper Name', tooltipField: 'shipper_name', tooltipComponentParams: { col: 'shipper' } },
    { field: 'consignee_name', headerName: 'Consignee Name', tooltipField: 'consignee_name', tooltipComponentParams: { col: 'consignee' } },
    {
      field: 'lading_status', headerName: 'P&D Status', editable: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: SelectList.STATUSES }, cellRenderer: ladingStatusFormatting, filter: 'agSetColumnFilter',
      filterParams: {
        values: SelectList.STATUSES,
      },
    },
    { field: 'carrier_name', headerName: 'Carrier Name', tooltipField: 'carrier_name', tooltipComponentParams: { col: 'carrier' } },
    { field: 'customer_name', headerName: 'Customer Name' },
    {
      field: 'shipper_locality',
      headerName: 'Pickup City',
      width: 150,
      // valueGetter: (params: ValueGetterParams) => {
      //   const { shipper_locality, shipper_region } = params.data || {};
      //   return [shipper_locality, shipper_region].filter(Boolean).join(", ");
      // }
    },
    {
      field: 'shipper_region',
      headerName: 'Pickup Region',
      width: 150,
    },
    {
      field: 'consignee_locality',
      headerName: 'Delivery City',
      width: 150,
      // valueGetter: (params: ValueGetterParams) => {
      //   const { consignee_locality, consignee_region } = params.data || {};
      //   return [consignee_locality, consignee_region].filter(Boolean).join(", ");
      // }
    },
    {
      field: 'consignee_region',
      headerName: 'Delivery Region',
      width: 150,
      // valueGetter: (params: ValueGetterParams) => {
      //   const { consignee_locality, consignee_region } = params.data || {};
      //   return [consignee_locality, consignee_region].filter(Boolean).join(", ");
      // }
    },
    {
      field: 'load_start',
      headerName: 'Pick-Up Date',
      width: 150,
      valueGetter: (params: ValueGetterParams) => { return dateToStringHelper(params.data.load_start) }, filter: 'agDateColumnFilter',
      cellStyle: (params: CellClassParams) => {
        // make background colour green if today
        let today: string = dateToStringHelper(new Date());
        if (params.value === today) return { backgroundColor: '#009933' } //green
        return null;
      },
      editable: true,
      cellEditor: DatePicker
    },
    {
      field: 'load_end',
      headerName: 'Delivery Date',
      width: 150,
      valueGetter: (params: ValueGetterParams) => { return dateToStringHelper(params.data.load_end) }, filter: 'agDateColumnFilter',
      cellStyle: (params: CellClassParams) => {
        // make background colour purple if today
        let today: string = dateToStringHelper(new Date());
        if (params.value === today) return { backgroundColor: 'violet' }
        return null;
      },
      editable: true,
      cellEditor: DatePicker
    },
    { field: 'trip_number', headerName: 'Trip Number' },
    {
      field: 'drop_trailer',
      headerName: 'Drop Trailer',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ['true', 'false']
      },
      cellRenderer: IconCellRendererComponent,
      cellRendererParams: {
        icon: 'fas fa-sharp fa-light fa-trailer',
      },
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: { values: ['yes', 'no'] },
      cellDataType: 'boolean'
    },
    { field: 'partial_or_full', headerName: 'Partial/Full' },
    { field: 'load_pallets', headerName: 'Pallets', initialWidth: 100 },
    { field: 'load_pieces', headerName: 'Pieces', initialWidth: 100 },
    { field: 'load_length', headerName: 'Load Length' },
    { field: 'load_length_unit', headerName: 'Feet/Inches' },
    { field: 'load_weight', headerName: 'Load Weight', initialWidth: 100 },
    { field: 'load_weight_actual', headerName: 'Actual Weight', initialWidth: 100 },
    { field: 'load_weight_unit', headerName: 'Weight Unit', initialWidth: 100 },
    {
      field: 'type_of_equipment', headerName: 'Trailer Type', initialWidth: 175,
      cellEditor: 'agSelectCellEditor', cellEditorParams: { values: Object.values(SelectList.TRAILER_TYPES) }, editable: true
    },
    { field: 'lading_id', headerName: 'Manifest #' },
    { field: 'drop_trailer_status', filter: 'agTextColumnFilter', sortable: true, headerName: 'Drop Trailer Status' },
    {
      field: 'expedited', headerName: 'Expedited',
      filterParams: {
        defaultOption: 'equals',
        filterOptions: ['equals'],
      },
      cellRenderer: IconCellRendererComponent,
      cellRendererParams: {
        icon: 'fas fa-truck-fast',
        color: ''
      },
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: { values: ['yes', 'no'] },
      cellDataType: 'boolean',
      initialWidth: 100
    },
    { field: 'customer_po', headerName: 'Customer PO' },
    { field: 'pickup_reference_number', headerName: 'Pickup #' },
    { field: 'delivery_reference_number', headerName: 'Delivery #' },
    { field: 'booking_number', headerName: 'Booking #' },
    { field: 'release_number', headerName: 'Release #' },
    { field: 'equipment_options', headerName: 'Trailer Option' },
    {
      field: 'created',
      headerName: 'Created',
      valueGetter: (params: ValueGetterParams) => { return dateToStringHelper(params.data.created) },
      filter: 'agDateColumnFilter'
    }
  ];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      buttons: ['apply', 'clear', 'reset']
    },
    autoHeight: true,
    resizable: true,
    tooltipComponent: TooltipComponent,
    // dunno wtf this is but it sounds funny undoRedoCellEditing: true
  };
  public rowModelType: RowModelType = 'serverSide';
  public cacheBlockSize = 100;
  public cacheOverflowSize = 2;
  public maxConcurrentDatasourceRequests = 2;
  public infiniteInitialRowCount = 1;
  public getRowId: GetRowIdFunc = (params: GetRowIdParams) => {
    return params.data.lading_uuid;
  };
  public rowData?: WorkOrder[];
  public themeClass: string ="ag-theme-ulaap";
  private gridApi!: GridApi<WorkOrder>;
  public gridVisible = true;
  public initialState =  JSON.parse(JSON.stringify(workOrderDefaultGridState));
  public gridOptions: GridOptions = {
    onGridPreDestroyed: (params: GridPreDestroyedEvent<WorkOrder>) => {
      console.log('Grid state on destroy (can be persisted)', params.state);
    },
  };

  constructor(private http: HttpClient, private cdRef: ChangeDetectorRef, private gridStateService: UserGridStateService) {}


  ngOnInit() {
    this.fetchAndApplyGridState();
  }

  fetchAndApplyGridState() {
    this.gridStateService.getUserGridState('work_orders').subscribe((state) => {
      if (state) {
        this.initialState = state;
      } else {
      }
      this.gridReady = true; 
    }, error => {
      console.error('Failed to fetch grid state:', error);
      this.gridReady = true; 
    });
  }



  printState(): void {
    console.log('Grid state', this.gridApi.getState());
  }

  onStateUpdated(params: StateUpdatedEvent<WorkOrder>): void {
    this.gridStateService.saveUserGridState('work_orders',params.state);
    console.log('State updated', params.state);
  }

  onGridReady(params: GridReadyEvent<WorkOrder>) {
    const dataSource: IServerSideDatasource = {
        getRows: (params: IServerSideGetRowsParams<any, any> & { sortModel: SortModelItem[], filterModel: any }) => {
          const sortModel = params.request.sortModel;
          const filterModel = params.request.filterModel;
          const url = this.buildUrl(params.request.startRow || 0, params.request.endRow || 0, sortModel, filterModel);
          this.gridApi = params.api;
          this.http.get<{ data: WorkOrder[], totalRows: number }>(url).subscribe(
            response => {
              console.log("work order data: " + JSON.stringify(response.data));
              params.success({ rowData: response.data, rowCount: response.totalRows });
            },
            error => {
              // Handle errors
              console.error('Error fetching work orders:', error);
              params.fail();
            }
          );
        }
      
    };
  
    // Set the datasource using setGridOption
    params.api.setGridOption('serverSideDatasource', dataSource);
  }

  private buildUrl(startRow: number, endRow: number, sortModel: SortModelItem[], filterModel: any): string {
    // Construct the URL with query parameters for startRow, endRow, filters, and sortModel
    const baseUrl = '/api/work_orders/work_orders.php';
    const filters = encodeURIComponent(JSON.stringify(filterModel));
    const sort = encodeURIComponent(JSON.stringify(sortModel));
    return `${baseUrl}?startRow=${startRow}&endRow=${endRow}&filters=${filters}&sortModel=${sort}`;
  }
}




function dateToStringHelper(dateInput: Date | string | null): string {
  if (!dateInput) {
    return 'Date not set';
  }
  const date = (typeof dateInput === 'string') ? new Date(dateInput) : dateInput;
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const weekday = weekdays[date.getDay()];
  const month = months[date.getMonth()];
  return `${weekday} ${month} ${date.getDate()} ${date.getFullYear()}`;
}

// for rendering lading status
function ladingStatusFormatting(params: ICellRendererParams) {
  let bgColor: string = '';
  let fontColor: string = 'black'

  // set button style according to value
  if (params.value.includes('Shipper')) {
    // shipper: soft blues
    if (params.value.includes('En Route')) {
      bgColor = '#c2e2ea';
    }
    else if (params.value.includes('Arrived')) {
      bgColor = '#a7d5e1';
    }
    else if (params.value.includes('Detained')) {
      bgColor = '#8dc8d8';
    }
    else if (params.value.includes('Loading'))
      bgColor = '#72bbce';
    else
      bgColor = '#a7d5e1';
  }
  // consignee: muted greens
  else if (params.value.includes('Consignee')) {
    if (params.value.includes('Delivered')) {
      bgColor = '#718355';
      fontColor = 'white';
    }
    else if (params.value.includes('Unloading')) {
      bgColor = '#87986a';
      fontColor = 'white';
    }
    else if (params.value.includes('Detained')) {
      bgColor = '#97a97c';
      fontColor = 'white';
    }
    else if (params.value.includes('Arrived'))
      bgColor = '#b5c99a';
    else if (params.value.includes('En Route'))
      bgColor = '#cfe1b9'
    else {
      bgColor = '#97a97c';
      fontColor = 'white';
    }
  }
  // load: lavenders. load completed is green
  else if (params.value.includes('Load')) {
    if (params.value === 'Load Check') bgColor = '#E1D8F7'
    else if (params.value === 'Load Incomplete') bgColor = '#C0A7EB'
    else if (params.value === 'Load Temperature Check') bgColor = '#D0BEF2'
    else if (params.value === 'Load Scale') bgColor = '#D7C8F3'
    else if (params.value === 'Load Damage') bgColor = '#E1D8F7'
    else if (params.value === 'Load Completed') bgColor = '#7cb36b'
  }
  // custom: pinks
  else if (params.value.includes('Customs')) {
    bgColor = '#ff9ebb';
    if (params.value === 'Arrived Customs') bgColor = '#ff9ebb'
    else if (params.value === 'Detained Customs') bgColor = '#ff7aa2'
    else if (params.value === 'Cleared Customs') bgColor = '#e05780'
  }
  // delay: dark shades
  else if (params.value.includes('Delay')) {
    fontColor = 'white';
    bgColor = '#14181d';
    if (params.value.includes('Traffic')) bgColor = '#231c35'
    if (params.value.includes('Weather')) bgColor = '#6e2a0c'
    if (params.value.includes('Mechanical')) bgColor = '#230000'
    if (params.value.includes('Accident')) bgColor = '#290000'
    if (params.value.includes('Inspection')) bgColor = '#360825'
    if (params.value.includes('Other')) bgColor = '#702632'
  }
  else {
    bgColor = '#343A40' //btn-dark 
    fontColor = 'white'
  }

  // html code to render for each cell
  let element =
    `
    <div class="btn-group">
      <button class="btn dropdown-toggle button-text-wrapper" style="background-color:${bgColor};color:${fontColor};border-radius:5px" >${params.value}</button>
    </div>
    `

  return element;
}